define('shared/remote/payment/creditCard/convertOptionsToPayload',[
],
function(    
){
    return function (creditCard) {
        if (!creditCard.name) {
            throw 'Name must be specified';
        }

        if (!creditCard.address) {
            creditCard.address = [];
        }

        if (!creditCard.expiration) {
            creditCard.expiration = {};
        }

        return {
            'FirstName': creditCard.name.given,
            'LastName': creditCard.name.family,
            'Number': creditCard.number,
            'ExpirationMonth': creditCard.expiration.month,
            'ExpirationYear': creditCard.expiration.year,
            'VerificationCode': creditCard.csc,
            'Address1': creditCard.address[0],
            'Address2': creditCard.address[1],
            'City': creditCard.city,
            'State': creditCard.state,
            'Country': creditCard.country,
            'PostalCode': creditCard.postalCode,
            'Telephone': creditCard.telephone
        };
    };
});
